import React from 'react';
import ui from './ProductAdminDashboard.module.css';

// Each tone is a soft tinted tile with a stronger icon colour (blue, green, amber, purple, rose)
const toneClass = (tone) => ui[`tone_${tone}`] || ui.tone_blue;

export function IconTile({ tone = 'blue', size = 'md', children }) {
  return <span className={`${ui.iconTile} ${size === 'sm' ? ui.iconTileSm : ''} ${toneClass(tone)}`}>{children}</span>;
}

// Summary figure with a coloured icon tile
export function StatTile({ tone, icon, title, value, hint }) {
  return (
    <div className={ui.statTile}>
      <IconTile tone={tone}>{icon}</IconTile>
      <div className={ui.statBody}>
        <span className={ui.statTitle}>{title}</span>
        <span className={ui.statValue}>{value}</span>
        {hint && <span className={ui.statHint}>{hint}</span>}
      </div>
    </div>
  );
}

// Section title with an icon tile and an optional action on the right
export function SectionHeading({ tone, icon, title, text, action }) {
  return (
    <div className={ui.sectionRow}>
      <div className={ui.sectionHead}>
        <IconTile tone={tone} size="sm">{icon}</IconTile>
        <div>
          <h2 className={ui.sectionTitle}>{title}</h2>
          {text && <p className={ui.sectionText}>{text}</p>}
        </div>
      </div>
      {action && <div className={ui.sectionAction}>{action}</div>}
    </div>
  );
}
